import { ConfirmTerminateAccountModalComponent } from '@1bill-app/components/confirm-terminate-account-modal/confirm-terminate-account-modal.component';
import { APP_CONFIG, ROUTE_SETTINGS_MAIN, ROUTE_USER_PROFILE } from '@1bill-app/constants';
import { ApiService } from '@1bill-app/services/api/api.service';
import { UserService } from '@1bill-app/services/user/user.service';
import { Component, OnInit } from '@angular/core';
import {
  AlertController,
  LoadingController,
  NavController,
  ToastController,
  ModalController
} from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-account-delete',
  templateUrl: './account-delete.page.html',
  styleUrls: ['./account-delete.page.scss'],
})
export class AccountDeletePage implements OnInit {
  title = 'Account Termination';
  _source = ROUTE_USER_PROFILE;
  isLoading = true;
  deleteData: any;
  constructor(
    private alertController: AlertController,
    private loadingController: LoadingController,
    private navCtrl: NavController,
    private toastController: ToastController,
    private logger: NGXLogger,
    private modalController: ModalController,
    private userService: UserService,
  ) {}

  ngOnInit() {}

  ionViewDidEnter() {
    this.userService.accountTerminationStatus().subscribe(
      (res) => {
        this.logger.log(res);
        this.deleteData = res.data;
        this.isLoading = false;
      },
      async (err) => {
        this.logger.error('accountTerminationStatus',err);
        this.isLoading = false;
        await this.errorAlert(true);
      },
    );
  }

  async requestAccountTerminationModal() {
    const modal = await this.modalController.create({
      component: ConfirmTerminateAccountModalComponent,
      cssClass: 'confirm-account-termination-modal'
    });

    await modal.present();

    modal.onWillDismiss().then((dismissResult) => {
      if (dismissResult?.role === 'confirm') {
        this.requestAccountTerminationFinal(dismissResult.data.terminationReason);
      }
    });
  }

  private async requestAccountTerminationFinal(terminationReason?: string) {
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: 'Please wait...',
      duration: 2000,
    });
    await loading.present();
    this.userService.requestAccountTermination(terminationReason).subscribe(
      async (res) => {
        this.deleteData = res.data;
        this.logger.log(res);
        await loading.dismiss();
      },
      async (err) => {
        this.logger.error('requestAccountTerminationFinal',err);
        await loading.dismiss();
        await this.errorAlert();
      },
    );
  }

  cancelAccountTerminationPopup() {
    this.userService.presentAccountCancelTerminationAlert().then((selection) => {
      if (selection) {
        this.cancelAccountTerminationFinal();
      }
    });
  }

  private async cancelAccountTerminationFinal() {
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: 'Please wait...',
      duration: 2000,
    });
    await loading.present();
    this.userService.cancelAccountTermination().subscribe(
      async (res) => {
        this.deleteData = null;
        await loading.dismiss();
        this.navCtrl.navigateBack(ROUTE_SETTINGS_MAIN);
        await this.presentToast('success', 'Successfully cancelled account termination.');
        this.logger.log(res);
      },
      async (err) => {
        this.logger.error('cancelAccountTermination',err);
        await loading.dismiss();
        await this.errorAlert();
      },
    );
  }

  async presentToast(color: 'success' | 'danger' | 'warning', message: string) {
    const toast = await this.toastController.create({
      message,
      duration: APP_CONFIG.TOAST_SUCCESS_DURATION,
      color,
      buttons: [
        {
          icon: 'close-circle-outline',
          role: 'cancel',
        },
      ],
    });
    toast.present();
  }

  async errorAlert(redirect = false) {
    const alert = await this.alertController.create({
      mode: 'ios',
      cssClass: 'bill-alert alert-icon',
      message:
        '<img src="assets/icon/alert/warning.svg" alt="warning-icon" /><h2 class="alert-title">Oops!</h2><p class="alert-text">Something went wrong! Please try again later.</p>',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Got it',
          handler: () => {},
        },
      ],
    });

    await alert.present();
    alert.onDidDismiss().then(() => {
      if (redirect) {
        this.navCtrl.navigateBack(ROUTE_SETTINGS_MAIN);
      }
    });
  }
}
